export enum SeasonType {
  SS = 'SS',
  FW = 'FW',
}

type seasonTypeConfig = {
  [key in SeasonType]?: {
    displayName: string
  }
}

const seasonTypeConfig: seasonTypeConfig = {
  SS: {
    displayName: 'S/S',
  },
  FW: {
    displayName: 'F/W',
  },
}

export const getDisplayName = (type: SeasonType) => {
  return (seasonTypeConfig[type] && seasonTypeConfig[type].displayName) || null
}
